import React from "react";
import {postDataAction} from "../../../store/actions/postDataAction";
import styles from "../../../static/css/pages.module.css";
import Modal from "../../../components/modal/modal";
import {connect} from "react-redux";
import * as consts from "../../../store/constants/sendData";
import ieSvg from "../../../components/icons/ieSvg";

class RegisterUnbind extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog: ''
    }
  }

  componentDidUpdate() {
    ieSvg()
  }

  dialogUnbind = () => {
    this.setState({
      dialog:'UNBIND'
    })
  }

  handleClose = () => {
    this.setState({
      dialog:''
    });
    this.props.fetchData('', this, consts.CLIENT_REGISTRATION_UNBIND);
  }

  handleUnbind = (e) => {
    let formData = '';
    this.props.fetchData(process.env.REACT_APP_GATE + "client/registration/unbind", this, consts.CLIENT_REGISTRATION_UNBIND, formData);
  }

  renderDialog(param) {
    switch (param) {
      case "ERROR":
        if(this.props.data.items.result.errorCode === 'TAXPAYER_UNBOUND' || this.props.data.items.result.errorCode === 'TAXPAYER_UNREGISTERED') {
          this.props.fetchData('', consts.CLIENT_REGISTRATION_UNBIND, null);
          window.location=process.env.PUBLIC_URL + "/page/needRegister";
          return null;
        }
        else {
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Что-то пошло не так"
          body={<div className={styles.article}>{this.props.data.items.result.errorMessage}<div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
        }
      case "TIMEOUT":
        return  <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Что-то пошло не так"
          body={<div className={styles.article}>Сервис временно недоступен, повторите операцию позже.<div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />
      case "SUCCESS":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_success"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Управление кабинетом налогоплательщика прекращено"
          body={<div className={styles.article}>
            Если передумаете, вы сможете привязать &laquo;{this.props.partnerName}&raquo; повторно через приложение.
            <div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
      default:
        return null;
    }
  }

  render() {
    return (
      <div>
        Если вы не хотите, чтобы &laquo;{this.props.partnerName}&raquo; управлял вашим кабинетом налогоплательщика, вы можете&nbsp;
        <span className={styles.link} onClick={this.dialogUnbind}>отозвать права</span> у Банка.<br />
        Ваша регистрация в ФНС в качестве самозанятого останется без изменений.
        <div>
          {this.props.data.items ?
            this.renderDialog(this.props.data.items.result.status)
            :
            this.state.dialog === 'UNBIND' ?
              <Modal
                class="dialog-success l-align_center"
                modalIcon="icon_question"
                viewbox="0 0 80 80"
                handleClick={this.handleClose.bind(this)}
                title={<div>Отозвать права у &laquo;{this.props.partnerName}&raquo; на управление вашим кабинетом налогоплательщика?</div>}
                body={<div className={styles.article}>
                  Ваша регистрация в ФНС в качестве самозанятого останется без изменений.<br />
                  Если передумаете, вы сможете привязать &laquo;{this.props.partnerName}&raquo; повторно через приложение.
                  <div className={styles.article}> </div>
                </div>}
                footer="l-align_right"
                link={this.handleUnbind.bind(this)}
                button="Отозвать права"
              />
              :
              null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.clientRegistrationUnbind})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types, body, el) => dispatch(postDataAction(url, parent, types, body, el))}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUnbind);
